import { render, staticRenderFns } from "./electrifyAccount.vue?vue&type=template&id=a89e9ace&scoped=true&"
import script from "./electrifyAccount.vue?vue&type=script&lang=js&"
export * from "./electrifyAccount.vue?vue&type=script&lang=js&"
import style0 from "./electrifyAccount.vue?vue&type=style&index=0&id=a89e9ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89e9ace",
  null
  
)

export default component.exports